import { gql } from '@apollo/client';

export const GET_STANDARDIZED_ADDRESS_LISTING = gql`
  query GetStandardizedAddressListing(
    $filters: StandardizedAddressFiltersInput
    $pageRequest: PageRequestTypeInput
  ) {
    getStandardizedAddressListing(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        fullStandardAddress
        latitude
        longitude
        unitType
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const ANALYZE_ADDRESS_SIMPLE = gql`
  query WhitelistAnalyzeAddressSimple(
    $streetAddress: String!
    $unit: String
    $city: String!
    $state: String!
    $zipCode: String!
    $forceExternalApiMatch: Boolean  
  ) {
    analyzeAddressSimple(
      streetAddress: $streetAddress
      unit: $unit
      city: $city
      state: $state
      zipCode: $zipCode
      forceExternalApiMatch: $forceExternalApiMatch
    ) {
      isValid
      validationReason
      normalizedComponents {
        addressLine1
        cityName
        stateAbbreviation
        zipcode
      }
      entityComponents {
          addressLine1
          addressLine2
          cityName
          stateAbbreviation
          zipcode
          idLog
      }        
    }
  }
`;
export interface StandardizedAddressType {
  id: string;
  fullStandardAddress: string;
  latitude: string | null;
  longitude: string | null;
  unitType: string | null;
  updatedAt: string;
}

export interface StandardizedAddressFiltersInput {
  id?: number;
  line1?: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
  city?: string;
  state?: string;
  zipcode?: string;
}

export interface PageRequestTypeInput {
  page: number;
  size: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface StandardizedAddressPageResponseType {
  content: StandardizedAddressType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetStandardizedAddressListingResponse {
  getStandardizedAddressListing: StandardizedAddressPageResponseType;
}

